export default __webpack_public_path__ + "static/media/footer-bg.1d336d53.webp";